//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'order-consign-return-detail',
  props: {
    id: {
      type: String,
      required: false
    }
  },
  components: {
    FormComponent: FormComponent
  }
};